module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/westernunion-e4933102d620322d8083c9fc59d39933.png";